import { render, staticRenderFns } from "./WidgetImageMapEditor.vue?vue&type=template&id=ec69afc2"
import script from "./WidgetImageMapEditor.vue?vue&type=script&lang=js"
export * from "./WidgetImageMapEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports